import { SET_DYNAMIC_COMPONENTS_DATA, RESET_DYNAMIC_COMPONENTS_DATA } from 'constants/actionTypes/dynamicComponent';
import PromotionListTargetedPAS from 'utils/features/PromotionListTargetedPAS';
import Location from 'utils/Location';
import Empty from 'constants/empty';

const dynamicComponentsFeatures = {
    // eslint-disable-next-line camelcase
    PromotionList_Targeted_PAS: PromotionListTargetedPAS
};

const setDynamicComponentsData = data => ({
    type: SET_DYNAMIC_COMPONENTS_DATA,
    payload: data
});

const resetDynamicComponents = () => ({
    type: RESET_DYNAMIC_COMPONENTS_DATA
});

function getRecognizedFeaturesWithTheirComponents(components) {
    const featuresMap = new Map();

    components.forEach(component => {
        if (component.features && Array.isArray(component.features)) {
            component.features.forEach(feature => {
                const featureType = feature.handlerType;

                if (dynamicComponentsFeatures[featureType]) {
                    if (!featuresMap.has(featureType)) {
                        featuresMap.set(featureType, {
                            feature: dynamicComponentsFeatures[featureType],
                            components: []
                        });
                    }

                    featuresMap.get(featureType).components.push(component);
                }
            });
        }
    });

    return Array.from(featuresMap.values());
}

function isOriginalPASScopePage() {
    return Location.isBasketPage() || Location.isBIPage() || Location.isOffersPage() || Location.isHomepage();
}

const processDynamicComponents = components => {
    const { isSampleSellThroughGwpEnabled = false, gwpSamples = Empty.Object } = Sephora.configurationSettings;

    // Exit early if original KS is off
    // Or if PAS expansion KS is off and current page is not in the original scope
    if (!isSampleSellThroughGwpEnabled || (!gwpSamples?.pasExpansion?.isEnabled && !isOriginalPASScopePage())) {
        return;
    }

    const recognizedFeaturesWithComponents = getRecognizedFeaturesWithTheirComponents(components);

    recognizedFeaturesWithComponents.forEach(featureGroup => {
        try {
            const FeatureClass = featureGroup.feature;
            const feature = new FeatureClass();
            feature.execute(featureGroup.components);
        } catch (error) {
            Sephora.logger.verbose('Error executing dynamic component feature: ', error);
        }
    });
};

export default {
    processDynamicComponents,
    setDynamicComponentsData,
    resetDynamicComponents
};
